import { render, staticRenderFns } from "./ModalAddEditAbsence.vue?vue&type=template&id=38f1ae2c&"
import script from "./ModalAddEditAbsence.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditAbsence.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditAbsence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports